import { dataSourcesTabsNames } from './constants';

export const getDataSourcesTabs = () => [
	{
		title: dataSourcesTabsNames.gnb,
		value: dataSourcesTabsNames.gnb,
		isVisible: true,
	},
];
